import { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { LocalizationProvider, TimePicker as MuiTimePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import PropTypes from 'prop-types';
import InputField from './InputField';

const LocalTimePicker = ({ error, helperText, label, sx, ...rest }) => {
  const [open, setOpen] = useState(false);
  // eslint-disable-next-line
  const classes = useStyles();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiTimePicker
        disableMaskedInput
        open={open}
        onClose={() => setOpen(false)}
        className={classes.root}
        fullWidth
        label={label}
        onChange={() => {}}
        {...rest}
        renderInput={(params) => (
          <InputField
            readOnly
            onClick={() => setOpen(true)}
            fullWidth
            {...params}
            helperText={helperText}
            className={classes.root}
            error={error}
            sx={sx}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default LocalTimePicker;

LocalTimePicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  helperText: PropTypes.string
};

LocalTimePicker.defaultProps = {
  label: '',
  value: null,
  error: null,
  helperText: ''
};

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiIconButton-edgeEnd': {
      marginRight: 0
    },

    '& input::placeholder': {
      opacity: 0
    },

    '& .MuiOutlinedInput-root .Mui-disabled': {
      background: '#EDEBE9'
    },

    '& .MuiSvgIcon-root': {
      color: 'transparent',
      fontSize: 15,
      stroke: '#8A8886'
    }
  }
}));
